export const AUTHCHECK = 'AUTHCHECK';